<template>
  <v-col cols="12" class="px-0">
    <sidebar-row style="padding: 0 !important">
      <data-input
        v-bind="searchInput"
        v-model="searchQuery"
        class="searchInput"
        hide-details
        prepend-inner-icon="mdi-magnify"
      ></data-input>
    </sidebar-row>
    <v-list class="py-0 custom-reports-list" dense>
      <v-radio-group v-model="computedSelectedReport" dense hide-details>
        <template v-for="report in reports">
          <v-list-item
            v-show="(fullListVisible || filteredReports.indexOf(report) < 4) && filteredReports.includes(report)"
            class="custom-reports-element hover-list-element px-2"
            :key="report.id"
          >
            <v-list-item-content>
              <v-list-item-title class="text-body-2">
                <v-row no-gutters class="flex-nowrap" align="center">
                  <v-col cols="auto" style="max-width: 50%">
                    <v-radio :value="report" :ripple="false"></v-radio>
                  </v-col>
                  <v-col cols="auto" style="max-width: 80%">
                    <v-tooltip bottom color="font" max-width="300">
                      <template #activator="{ on }">
                        <div class="text-body-2 custom-reports-text" v-on="on">
                          {{ report.name }}
                        </div>
                      </template>
                      <div style="word-break: break-all;">
                        {{ report.name }}
                      </div>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-radio-group>
      <list-toggler v-if="filteredReports.length > 4" v-model="fullListVisible" />
    </v-list>
  </v-col>
</template>

<script>
import ListToggler from '@/components/ListToggler';
import DataInput from '@/components/DataInput';
import SidebarRow from '@/components/SidebarRow';

import { debounce } from 'lodash';

export default {
  name: 'ZDMCustomReportsList',
  components: {
    ListToggler,
    DataInput,
    SidebarRow,
  },
  props: {
    reports: {
      type: Array,
      required: true,
    },
    selectedReport: {
      type: Object,
      required: true,
    },
  },
  data: vm => ({
    fullListVisible: false,
    filteredReports: [],
    searchInput: {
      dataType: {
        name: 'text',
      },
      label: vm.$i18n.t('default.find'),
    },
    searchQuery: undefined,
  }),
  computed: {
    computedSelectedReport: {
      get() {
        return this.selectedReport;
      },
      set(nV) {
        this.$emit('update:selectedReport', nV);
      },
    },
  },
  methods: {
    search(val) {
      if (val) {
        this.filteredReports = this.reports.filter(layer => {
          return layer.name.toLowerCase().includes(val.toLowerCase());
        });
      } else {
        this.filteredReports = [...this.reports];
      }
    },
  },
  created() {
    this.computedSelectedReport = this.reports.length > 0 ? this.reports[0] : {};
  },
  mounted() {
    this.$watch('searchQuery', debounce(this.search, 200));
    this.filteredReports = [...this.reports];
  },
};
</script>

<style lang="scss" scoped>
.custom-reports-element {
  @include border(bottom);
  text-align: left;
  min-height: 36px;
  max-height: 36px;
}
.custom-reports-list {
  border-radius: 4px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), 0px -1px 0px rgba(0, 0, 0, 0.15) !important;
}
.custom-reports-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

::v-deep {
  .v-input--radio-group {
    padding: 0 !important;
  }
  .searchInput {
    max-width: 250px;
    margin-left: auto;
    .v-label {
      font-size: 15px !important;
    }
    .v-input__slot {
      min-height: 32px !important;
      padding: 0 12px !important;
    }
    .v-input__append-inner {
      margin: 6px !important;
    }
    .v-input__prepend-inner {
      margin-top: 7px !important;
      .v-input__icon {
        .v-icon {
          font-size: 16px;
          padding-bottom: 5px;
        }
      }
    }
    .v-text-field--outlined.v-input--dense .v-label {
      top: 7px;
    }
    .v-text-field__slot input {
      font-size: 12px !important;
    }
  }
}
</style>
